import "../../util/yup-locale";
import React from "react";
import { createRoot } from "react-dom/client";
import { LeadForm } from "../../features/lead-form";
import * as Sentry from "@sentry/react";

const elements = document.getElementsByTagName("lead-form");

if (elements.length > 0) {
  (async () => {
    for (let i = 0; i < elements.length; i++) {
      const element = elements.item(i) as HTMLElement;
      const root = createRoot(element);
      root.render(
        <Sentry.ErrorBoundary
          fallback={
            <p>
              Der opstod en kritisk fejl. Genindlæs siden og prøv igen, eller
              kontakt support for hjælp.
            </p>
          }
        >
          <LeadForm
            csrf={element.dataset.csrf!}
            forceMobile={element.dataset.forcemobile === "true" ? true : false}
            maxWidth={element.dataset.maxwidth}
            redirectToBoligContent={
              element.dataset.redirecttoboligcontent === "true" ? true : false
            }
            eventSection={element.dataset.eventsection!}
          />
        </Sentry.ErrorBoundary>
      );
    }
  })();
}
